
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { BuildingStateService } from '../../../core/services/building-state.service';
import _ from 'lodash';

@Component({
  selector: 'app-building-info',
  imports: [],
  templateUrl: './building-info.html',
  styleUrl: './building-info.css',
})

export class BuildingInfo implements OnInit, OnChanges {
  @Input() data!: any;
  @Input() screenX = 0;
  @Input() screenY = 0;
  constructor(private buildingStateService: BuildingStateService) { }

  ngOnInit(): void { 
    // console.log('Building Info Data:', this.data);
  }

  ngOnChanges(): void {
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    this.screenX = Math.max(0, Math.min(this.screenX, viewportWidth - 280));
    this.screenY = Math.max(0, Math.min(this.screenY, viewportHeight - 300));
  }

  closePopup(): void {
    this.buildingStateService.clearBuildingState();
  }
}
